import map from 'lodash/map';
import {
  GET_BANKACCOUNT,
  ADD_BANKACCOUNT,
  UPDATE_BANKACCOUNT,
  ADD_SHEBA,
  UPDATE_SHEBA
} from '../../constants';
import { api } from '../api';
import {
  AddBankAccountReqBody,
  AddBankAccountResponse,
  AddIbanReqBody,
  AddIbanResponse,
  GetUserBankAccountResponse,
  UpdateBankAccountReqBody,
  UpdateBankAccountResponse,
  UpdateIbanReqBody,
  UpdateIbanResponse
} from './types';

export const financialSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getBankAccount: build.query<GetUserBankAccountResponse, void>({
      query: () => `${GET_BANKACCOUNT}`,
      transformResponse: (response: GetUserBankAccountResponse) => {
        if (response.data.length > 0) {
          const arr = response.data || [];
          return {
            data: map(arr, (item) => ({
              ...item,
              isLoading: false
            }))
          };
        }
        return response;
      }
    }),
    addBankAccount: build.mutation<
      AddBankAccountResponse,
      AddBankAccountReqBody
    >({
      query(data) {
        return {
          url: ADD_BANKACCOUNT,
          method: 'POST',
          body: data
        };
      }
    }),
    updateBankAccount: build.mutation<
      UpdateBankAccountResponse,
      UpdateBankAccountReqBody
    >({
      query(data) {
        return {
          url: UPDATE_BANKACCOUNT,
          method: 'POST',
          body: data
        };
      }
    }),
    addIban: build.mutation<AddIbanResponse, AddIbanReqBody>({
      query(data) {
        return {
          url: ADD_SHEBA,
          method: 'POST',
          body: data
        };
      }
    }),
    updateIban: build.mutation<UpdateIbanResponse, UpdateIbanReqBody>({
      query(data) {
        return {
          url: UPDATE_SHEBA,
          method: 'POST',
          body: data
        };
      }
    })
  }),

  overrideExisting: false
});

export const {
  useGetBankAccountQuery,
  useLazyGetBankAccountQuery,
  useAddBankAccountMutation,
  useUpdateBankAccountMutation,
  useAddIbanMutation,
  useUpdateIbanMutation
} = financialSlice;
